import { useState, useEffect } from "react";
import Api from "../functions/Api";
const useUser = () => {
  const [ejecutaapi] = Api();
  const [data, setData] = useState([]);
  const [column] = useState([
    { title: "Estado", field: "Activo", type: "boolean" },
    { title: "Usuario", field: "Usuario", type: "string" },
    { title: "Nombre", field: "Nombre", type: "string" },
    { title: "Apellido P.", field: "ApellidoP", type: "string" },
    { title: "Apellido M.", field: "ApellidoM", type: "string" },
    { title: "Correo", field: "Correo", type: "string" },
    { title: "Rol", field: "Rol", type: "string" },
    { title: "ID_ROL", field: "ID_ROL", type: "numeric", hidden: true },
    {
      title: "Ultima modificacion",
      field: "Fecmod",
      type: "datetime",
      editable: "never",
      hidden: true
    },
    {
      title: "Usuario Modificacion",
      field: "Usrmod",
      type: "string",
      editable: "never",
      hidden: true
    }
  ]);
  const traeUsuarios = () => {
    let usuario = localStorage.getItem("user");
    if (!usuario) return;
    let body = JSON.stringify({
      idUsuario: -1,
      Usuario: JSON.parse(usuario).email
    });
    ejecutaapi("buscausuario", body).then(
      result => {
        if (result && result.result && result.result[0]) {
          setData(result.result[0]);
        }
      },
      error => {
        console.error(error);
      }
    );
  };
  const insertaUsuario = async (datos) => {
    let usuario = localStorage.getItem("user");
    if (!usuario) return { Ok: false, error: "Sesión no válida" };
    const body = JSON.stringify({
      pUsuario: datos.pUsuario,
      pClave: datos.pClave,
      pCorreo: datos.pCorreo,
      pNombre: datos.pNombre,
      pApellidoP: datos.pApellidoP,
      pApellidoM: datos.pApellidoM || "",
      pIdRol: datos.pIdRol,
      user: JSON.parse(usuario).email
    });
    return ejecutaapi("insertausuario", body);
  };

  const actualizaUsuario = async (datos) => {
    let usuario = localStorage.getItem("user");
    if (!usuario) return { Ok: false, error: "Sesión no válida" };
    const body = JSON.stringify({
      idUsuario: datos.idUsuario,
      pUsuario: datos.pUsuario,
      pClave: datos.pClave,
      pCorreo: datos.pCorreo,
      pNombre: datos.pNombre,
      pApellidoP: datos.pApellidoP,
      pApellidoM: datos.pApellidoM || "",
      pIdRol: datos.pIdRol,
      Activo: datos.Activo,
      user: JSON.parse(usuario).email
    });
    return ejecutaapi("actualizausuario", body);
  };

  // Desbloqueo con endpoint dedicado: solo manda el id, evitando reenviar todos
  // los campos del usuario (lo que abre la puerta a corromper datos por error).
  const desbloqueaUsuario = async (idUsuario) => {
    let usuario = localStorage.getItem("user");
    if (!usuario) return { Ok: false, error: "Sesión no válida" };
    const body = JSON.stringify({
      idUsuario,
      user: JSON.parse(usuario).email
    });
    return ejecutaapi("desbloqueausuario", body);
  };

  useEffect(() => {
    traeUsuarios();
  }, []);

  return {
    data,
    column,
    traeUsuarios,
    insertaUsuario,
    actualizaUsuario,
    desbloqueaUsuario
  };
};

export default useUser;
